var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fill-height background"},[_c('AdminNavbar'),(_vm.environment)?[_c('div',{staticClass:"fill-height enviroment"},[_c('dashboard-app-bar'),_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{attrs:{"environment":_vm.environment}})],1)],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }